import { InventoryAdjustmentReasonListPage } from '@/features/inventory-adjustment-reason/pages/InventoryAdjustmentReasonListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/inventory-adjustment-reason/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["inventory_adjustment_reason.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InventoryAdjustmentReasonListPage,
})
